export default __webpack_public_path__ + "static/referral2-e32f6ba9fc5bab136efe394403cd740f.png";